import { ServiceOrderStatus } from '../../../serviceOrders/serviceOrders/serviceOrder.types';
import { ServiceOrdersTableColumns } from '../../../serviceOrders/serviceOrders/table/ServiceOrdersTableColumns';
import { SortDirection, TableSort } from '../../../sharedComponents/table/SortedTableHeader';
import { GetServiceOrderExcelQueryParams } from '../../serviceOrdersApi';
import { mapServiceTypesToApiServiceTypes } from './serviceTypeMapper';
import {
    ApiServiceOrderExcelQueryParameter,
    ServiceOrderApiSort,
} from '../../types/serviceOrder/queryParameterApi.types';
import { ApiServiceOrderStatus } from '../../types/serviceOrder/serviceOrdersApi.types';

const mapServiceOrderStatusToApiServiceOrderStatus = (status: ServiceOrderStatus): ApiServiceOrderStatus => {
    switch (status) {
        case ServiceOrderStatus.OPEN:
            return ApiServiceOrderStatus.OPEN;
        case ServiceOrderStatus.COMPLETED:
            return ApiServiceOrderStatus.COMPLETED;
        case ServiceOrderStatus.CANCELLED:
            return ApiServiceOrderStatus.CANCELLED;
    }
};

export const mapServiceOrderStatusesToApiStatuses = (
    statusFilter: ServiceOrderStatus[],
): ApiServiceOrderStatus[] | undefined =>
    statusFilter.length === 0 ? undefined : statusFilter.map(mapServiceOrderStatusToApiServiceOrderStatus);

export const mapToServiceOrderApiSort = (sorting: TableSort<ServiceOrdersTableColumns>): ServiceOrderApiSort => {
    const sortDirection = sorting.dir;
    if (sortDirection === SortDirection.ASCENDING) {
        switch (sorting.column) {
            case ServiceOrdersTableColumns.SERVICE_CODE:
                return ServiceOrderApiSort.TYPE_ASC;
            case ServiceOrdersTableColumns.EXECUTION_DATE_START:
                return ServiceOrderApiSort.STARTED_AT_ASC;
            case ServiceOrdersTableColumns.EXECUTION_DATE_END:
                return ServiceOrderApiSort.COMPLETED_AT_ASC;
            case ServiceOrdersTableColumns.STATUS:
                return ServiceOrderApiSort.STATUS_ASC;
            case ServiceOrdersTableColumns.ORDER_ISSUE_DATE:
                return ServiceOrderApiSort.ORDER_ISSUED_AT_ASC;
            case ServiceOrdersTableColumns.LOCATION_ID:
                return ServiceOrderApiSort.LOCATION_IDENTIFIER_ASC;
        }
    } else if (sortDirection === SortDirection.DESCENDING) {
        switch (sorting.column) {
            case ServiceOrdersTableColumns.SERVICE_CODE:
                return ServiceOrderApiSort.TYPE_DESC;
            case ServiceOrdersTableColumns.EXECUTION_DATE_START:
                return ServiceOrderApiSort.STARTED_AT_DESC;
            case ServiceOrdersTableColumns.EXECUTION_DATE_END:
                return ServiceOrderApiSort.COMPLETED_AT_DESC;
            case ServiceOrdersTableColumns.STATUS:
                return ServiceOrderApiSort.STATUS_DES;
            case ServiceOrdersTableColumns.ORDER_ISSUE_DATE:
                return ServiceOrderApiSort.ORDER_ISSUED_AT_DESC;
            case ServiceOrdersTableColumns.LOCATION_ID:
                return ServiceOrderApiSort.LOCATION_IDENTIFIER_DESC;
        }
    }
    throw new Error('forgot to implement mapper for sorting or column');
};

export const mapToServiceOrderExcelQueryParameters = (
    queryParameters: GetServiceOrderExcelQueryParams,
): ApiServiceOrderExcelQueryParameter => ({
    service_location: queryParameters.location,
    statuses: queryParameters.statuses && mapServiceOrderStatusesToApiStatuses(queryParameters.statuses),
    service_types: queryParameters.serviceTypes && mapServiceTypesToApiServiceTypes(queryParameters.serviceTypes),
    order_issued_at_after: queryParameters.orderIssuedAtAfter?.toISOString(),
    order_issued_at_before: queryParameters.orderIssuedAtBefore?.toISOString(),
});
